"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyticsDrivers = void 0;
const tokens_1 = require("../tokens");
const fns_1 = require("../helpers/fns");
exports.analyticsDrivers = new Map([
    [
        tokens_1.TRACKIFY_DEBUG,
        () => (0, fns_1.isBrowser)() ? Promise.resolve().then(() => __importStar(require('./debug.browser-driver'))).then(module => module.default)
            : Promise.resolve().then(() => __importStar(require('./debug.server-driver'))).then(module => module.default)
    ],
    [
        tokens_1.TRACKIFY_GTM,
        () => (0, fns_1.isBrowser)() ? Promise.resolve().then(() => __importStar(require('./gtm.browser-driver'))).then(module => module.default)
            : Promise.resolve().then(() => __importStar(require('./gtm.server-driver'))).then(module => module.default)
    ],
    [
        tokens_1.TRACKIFY_USERCOM,
        () => (0, fns_1.isBrowser)() ? Promise.resolve().then(() => __importStar(require('./usercom.browser-driver'))).then(module => module.default)
            : Promise.resolve().then(() => __importStar(require('./usercom.server-driver'))).then(module => module.default)
    ],
    [
        tokens_1.TRACKIFY_SYNERISE,
        () => (0, fns_1.isBrowser)() ? Promise.resolve().then(() => __importStar(require('./synerise.browser-driver'))).then(module => module.default)
            : Promise.resolve().then(() => __importStar(require('./synerise.server-driver'))).then(module => module.default)
    ]
]);
//# sourceMappingURL=index.js.map